/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useEffect, useState } from 'react';
import { INPUT_SPINNER_SIZES } from '../../utils/constants/inputSpinner';
import { Button, Icon, InputSpinnerWrapper, InputWrapper } from './styles';

export type InputSpinnerProps = {
  /**
   * Attribute to define the input value
   */
  value?: number;
  /**
   * Attribute to define the function when on change the input value
   */
  onChange?: (value: number) => void;
  /**
   * Attribute to define minimum value available
   */
  min?: number;
  /**
   * Attribute to define maximum value available
   */
  max?: number;
  /**
   * Attribute to define the size of the Input Spinner
   */
  size?: typeof INPUT_SPINNER_SIZES[number];
};

export const defaultProps: InputSpinnerProps = {
  size: 'md',
};

const InputSpinner: React.FC<InputSpinnerProps> = ({ value, onChange, min, max, size }) => {
  const [currentValue, setCurrentValue] = useState<string>(value?.toString() || '');

  const getValueToInt = () => {
    return parseInt(currentValue || '0');
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = parseInt(event.currentTarget.value);
    if (max !== undefined) {
      if (inputValue > max || inputValue < min) {
        return false;
      }
    }
    setCurrentValue(inputValue.toString());
  };

  const handleClickDecrease = () => {
    const valueToInt = getValueToInt();
    if (min !== undefined) {
      if (valueToInt === min) {
        return false;
      }
    }
    setCurrentValue((valueToInt - 1).toString());
  };

  const handleClickIncrease = () => {
    const valueToInt = getValueToInt();
    if (max !== undefined) {
      if (valueToInt === max) {
        return false;
      }
    }
    setCurrentValue(((valueToInt || 0) + 1).toString());
  };

  useEffect(() => {
    if (onChange !== undefined) {
      onChange(getValueToInt());
    }
  }, [currentValue]);

  return (
    <InputSpinnerWrapper data-testid="input-spinner" size={size}>
      <Button onClick={handleClickDecrease} data-testid="button-decrease">
        <Icon data-testid="decrement-icon">&#8722;</Icon>
      </Button>
      <InputWrapper
        type="number"
        value={currentValue}
        onChange={handleChange}
        data-testid="input"
        min={min}
        max={max}
        pattern="\d*"
      />
      <Button onClick={handleClickIncrease} data-testid="button-increase">
        <Icon>&#43;</Icon>
      </Button>
    </InputSpinnerWrapper>
  );
};

InputSpinner.defaultProps = defaultProps;

export default InputSpinner;
